import { McpClient } from '../mcp-client';
import type { TurnState } from '../../types';
import { DrivingResponseTracker } from '../driving-response';

/** Mixin helper: a class constructor accepting any args, typed as producing at least T. */
export type Constructor<T = {}> = new (...args: any[]) => T;

export const CHAT_TIMEOUT_MS = 240_000;

/**
 * Holds the state shared across ChatOrchestrator's split-out method groups
 * (tools-handle.ts, turn-handle.ts) so those mixins can reach it via `this`
 * without each one re-declaring the same private fields.
 */
export class ChatOrchestratorBase {
  protected mcpClient: McpClient;
  protected shadow: ShadowRoot;
  protected mcpReadyPromise: Promise<void> | null = null;
  protected turns: Map<string, TurnState> = new Map();
  protected confirmationTimeout: ReturnType<typeof setTimeout> | null = null;
  protected drivingResponseTracker = new DrivingResponseTracker();
  protected approvedTools = new Set<string>();

  constructor(mcpClient: McpClient, shadow: ShadowRoot) {
    this.mcpClient = mcpClient;
    this.shadow = shadow;
  }

  setMcpReadyPromise(promise: Promise<void>): void {
    this.mcpReadyPromise = promise;
  }

  updateShadow(shadow: ShadowRoot): void {
    this.shadow = shadow;
  }
}
